import { ReactNode } from 'react'

interface SectionLabelProps {
  children: ReactNode
}

export function SectionLabel({ children }: SectionLabelProps) {
  return (
    <div className="flex items-center gap-2 col-span-full">
      <span className="t-xs text-tertiary whitespace-nowrap">{children}</span>
      <div className="flex-1 h-px bg-neutral-200" />
    </div>
  )
}
